const E = 5e3, _ = 5e6;
export {
  _ as CREATE_POI_MAX_AREA_SIZE,
  E as CREATE_POI_MIN_AREA_SIZE
};
//# sourceMappingURL=index.es357.js.map
